<template>
  <div class="h-full">
    <TrustPilotStars
      class="h-8 w-32"
      :stars="stars"
    />

    <p class="font-semibold py-2">
      {{ review.title }}
    </p>

    <!-- eslint-disable vue/no-v-html -->
    <div
      class="font-light pt-1"
      v-html="review.text"
    />
    <!-- eslint-enable vue/no-v-html -->

    <p class="text-gray-500 pt-4">
      {{ review.name }}
    </p>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import TrustPilotStars from '@timon/js/Components/TrustPilotStars.vue';

const props = defineProps({
  review: {
    type: Object,
    required: true,
  },
});

const stars = ref(parseInt(props.review.stars));
</script>
